import React from "react";
import { Icon } from "storefront/Icon";

type Props = Icon & {
  fill?: string;
};

const Check = ({
  width = "14px",
  height = "14px",
  fill = "black",
  className,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.44333 11.1354L11.8946 0.481995L13.6054 1.51797L6.50098 13.25H4.47706L0.428711 7.42256L2.07125 6.28148L5.44333 11.1354Z"
      fill={fill}
    />
  </svg>
);

export default Check;
